module.exports = __webpack_public_path__ + "media/images/favicon-bdc45ad9344655aad3f36a820a3c8b38.ico";